(function () {
  'use strict';

  // ── Column auto-fit ──────────────────────────────────────────
  // Sets --rvp-cols on the grid based on actual item count + viewport,
  // so the last row is always full with no orphan empty cells.
  function setRvpCols() {
    var grid = document.getElementById('rvp-grid');
    if (!grid) return;
    var count = grid.querySelectorAll('.rvp-card').length;
    if (!count) return;

    var w = window.innerWidth;
    // 6-up from 1240px so ordinary laptops get six, not five.
    var maxCols = w > 1240 ? 6
                : w > 1040 ? 5
                : w >  900 ? 4
                : w >  540 ? 3
                :             2;

    // Fill the row. This used to pick the largest divisor of the item count so the last
    // row was never short — but that quietly capped the grid (8 items divides by 4, so it
    // could never reach 6). A short last row is normal in a grid; fewer, wider cards is
    // the worse trade.
    var cols = Math.min(count, maxCols);

    grid.style.setProperty('--rvp-cols', cols);
  }

  // Re-run on resize (debounced)
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(setRvpCols, 150);
  });

  // Watch for the RVP custom element swapping in real cards
  var rvpEl = document.querySelector('recently-viewed-products');
  if (rvpEl) {
    new MutationObserver(setRvpCols).observe(rvpEl, { childList: true, subtree: true });
  }

  // Run immediately in case content already rendered
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setRvpCols);
  } else {
    setRvpCols();
  }

  // ── Quantity stepper ─────────────────────────────────────────
  // A select fires `change`, not `click`. Choosing an option only arms the Add To Basket
  // button; an option with no stock keeps the pre-order route via the product page.
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('.rvp-select');
    if (!sel) return;
    var cta = sel.closest('.rvp-card-cta');
    if (!cta) return;
    var add = cta.querySelector('.rvp-btn--atc');
    if (!add) return;
    var opt = sel.options[sel.selectedIndex];
    add.dataset.variantId = sel.value;
    var sellable = opt && opt.dataset.available !== 'false';
    add.dataset.preorder = sellable ? '' : 'true';
    add.classList.toggle('rvp-btn--preorder', !sellable);
    add.textContent = sellable ? 'Add To Basket' : 'Pre-Order';
  });

  document.addEventListener('click', function (e) {

    var qtyBtn = e.target.closest('.rvp-qty__btn');
    if (qtyBtn) {
      var input = qtyBtn.closest('.rvp-qty').querySelector('.rvp-qty__input');
      var val = parseInt(input.value, 10) || 1;
      input.value = qtyBtn.dataset.action === 'plus'
        ? Math.min(val + 1, 99)
        : Math.max(val - 1, 1);
      return;
    }

    // ── Add to basket ────────────────────────────────────────────
    var atcBtn = e.target.closest('.rvp-btn--atc');
    if (!atcBtn || atcBtn.disabled) return;

    var card   = atcBtn.closest('.rvp-card');
    var qtyInp = card && card.querySelector('.rvp-qty__input');
    var qty    = qtyInp ? (parseInt(qtyInp.value, 10) || 1) : 1;
    if (atcBtn.dataset.preorder === 'true' && atcBtn.dataset.productUrl) {
      window.location.href = atcBtn.dataset.productUrl;
      return;
    }
    var vid    = parseInt(atcBtn.dataset.variantId, 10);

    atcBtn.disabled     = true;
    atcBtn.textContent  = 'Adding…';

    var cartDrawer  = document.querySelector('cart-drawer');
    var requestBody = { id: vid, quantity: qty };
    if (cartDrawer) requestBody.sections = ['cart-drawer', 'cart-icon-bubble'];

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body:    JSON.stringify(requestBody)
    })
    .then(function (r) { if (!r.ok) throw r; return r.json(); })
    .then(function (response) {
      atcBtn.textContent = '✓ Added';
      atcBtn.classList.add('rvp-btn--done');

      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(response);
      } else {
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: response }));
      }

      setTimeout(function () {
        atcBtn.disabled    = false;
        atcBtn.classList.remove('rvp-btn--done');
        atcBtn.textContent = 'Add To Basket';
      }, 2500);
    })
    .catch(function () {
      atcBtn.disabled    = false;
      atcBtn.textContent = 'Add To Basket';
    });
  });
})();
